import { render } from "./ImageTemplateMessageView.vue?vue&type=template&id=c314af00&scoped=true"
import script from "./ImageTemplateMessageView.vue?vue&type=script&lang=js"
export * from "./ImageTemplateMessageView.vue?vue&type=script&lang=js"

import "./ImageTemplateMessageView.vue?vue&type=style&index=0&id=c314af00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c314af00"]])

export default __exports__